<template>
  <v-card>
    <v-form ref="formAddController" v-model="valid" lazy-validation>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="5">
            <h3 class="pb-1">Заполнение данных</h3>
            <template>
              <v-text-field
                v-model="installationDateTime"
                label="Дата создания"
                outlined
                dense
                hide-details
                flat
                readonly
                class="input input-search pb-4"
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-combobox
              v-model="formController.address"
              @keyup="startTypingTimer"
              :rules="[
                v => !!v || 'Поле обязательно для заполнения',
              ]"
              :items="addresses"
              item-text="addresses"
              :search-input.sync="searchAddress"
              prepend-inner-icon="mdi-rename-box-outline"
              return-object
              flat
              label="Адрес"
              outlined
              dense
            ></v-combobox>

            <v-autocomplete
              label="Район (только для г. Саранск)"
              :items="district"
              :item-text="item => (item.name) + ' (' + displayCity(item.city_id) + ')'"
              item-value="id"
              prepend-inner-icon="mdi-map-marker-radius-outline"
              v-model='formController.region'
              type="string"
              outlined
              :disabled="!isDistrict"
              dense
              flat
              clearable
            />

            <v-text-field
              label="Название в моб. приложении"
              v-model='formController.name'
              prepend-inner-icon="mdi-rename-outline"
              type="string"
              outlined
              dense
              clearable
              flat
            ></v-text-field>
            <BaseNewBindingDoorphone
              @addDoorphones="handleAddDoorphones"
              @deleteDoorphones="handleDeleteDoorphones"
              :selected-devices="selectedDevices"
            />
          </v-col>
          <v-col class="pb-0">
            <v-card>
              <v-card-title>
                <span>Устройства</span>
                <v-col cols="10" md='9'>
                  <v-text-field
                    v-model="searchDevice"
                    label="Поиск по IP адресу"
                    dense
                    autocomplete="chrome-off"
                    hide-details
                    @keyup="(e) => e.keyCode === 13 && filterDevices()"
                  ></v-text-field>
                </v-col>
                <v-btn
                  dark
                  class="btn blue darken-3 white px-7 text-none"
                  @click.prevent="filterDevices"
                >
                  Поиск
                </v-btn>
              </v-card-title>
              <v-data-table
                class="table"
                v-model="selectedDevices"
                :options.sync="universalOptions"
                :server-items-length="universalTotalDevices"
                :headers="headersDevices"
                :items="devices"
                item-key="id"
                show-select
                :footer-props="{
                    'items-per-page-options': [10, 20, 50, 100],
                  }"
                :single-select="true"
                :disable-sort="true"
              >
              </v-data-table>
            </v-card>
            <v-col cols="12" v-if="errorDevice">
              <v-alert
                type="error"
                dense
                outlined
              >
                Выберите устройство
              </v-alert>
            </v-col>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="ml-3">
        <div class="my-2">
          <v-btn
            large
            color="success"
            class="text-none"
            dark
            @click="validate()"
          >
            Сохранить
          </v-btn>
          <v-btn
            large
            class="ma-2 text-none"
            outlined
            dense
            hide-details
            color="error"
            @click.prevent="returnControllers()"
          >
            Отменить
          </v-btn>
        </div>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { headersDevices } from '../../../doorphone/EditDoorphone/consts';
import watchTableOptions from '../../../../mixins/watchTableOptions';
import BaseNewBindingDoorphone from '@/components/BaseNewBindingDoorphone';

export default {
  name: 'NewController',
  mixins: [watchTableOptions],
  components: { BaseNewBindingDoorphone },
  data () {
    return {
      valid: true,
      searchDevice: '',
      isNewDate: new Date().toISOString().substr(0, 10),
      isFirstLoading: false,
      loading: true,
      searchAddress: '',
      isDistrict: false,
      value: '',
      universalTotalDevices: 0,
      typingTimer: null,
      universalOptions: {
        itemsPerPage: 10,
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      headersDevices,
      selectedDevices: [],
      selectedDoorphones: [],
      errorDevice: false,
      formController: {
        address: '',
        region: null,
        name: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      devices: 'Device/devices',
      addresses: 'Doorphone/addresses',
      district: 'Doorphone/districts',
    }),
    installationDateTime () {
      if (this.isNewDate) {
        const date = new Date(this.isNewDate);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('ru-RU', options);
      } else {
        return '';
      }
    },
  },
  watch: {
    universalOptions (curr, prev) {
      this.handleOptionsChange(curr, prev, () => {
        this.universalChangePage();
      });
    },
  },
  methods: {
    ...mapActions({
      loadDevices: 'Device/getDevices',
      newController: 'Controllers/newController',
      getAddressSearch: 'Doorphone/getAddressSearch',
    }),
    validateKeyUp (e) {
      if (e.keyCode === 13) {
        this.filterDoorphones();
      }
    },
    displayCity (item) {
      switch (item) {
        case 1: return 'Ульяновск';
        case 2: return 'Саранск';
        default: return '';
      }
    },
    handleAddDoorphones (data) {
      this.selectedDoorphones = data;
    },
    handleDeleteDoorphones (itemToDelete) {
      this.selectedDoorphones = this.selectedDoorphones.filter(doorphone => doorphone !== itemToDelete.id.toString());
    },
    updateAddressSearch () {
      const val = this.formController.address;
      if (val && this.isDistrict) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(() => {
          if (!this.isFirstLoading && val) {
            this.getAddressSearch({
              value: val,
            })
              .then((res) => {
                this.formController.region = null;
                this.isDistrict = !!res.districts[0];
              });
          }
        }, 600);
      }
    },
    startTypingTimer (val) {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(() => {
        if (!this.isFirstLoading && val.srcElement._value) {
          this.getAddressSearch({
            value: val.srcElement._value,
          })
            .then((res) => {
              this.region = null;
              this.isDistrict = !!res.districts[0];
            });
        }
      }, 600);
    },
    filterDevices () {
      this.universalOptions.page = 1;
      this.universalChangePage();
    },
    universalChangePage () {
      const filters = { free: 1 };
      filters.model_id = '8';

      if (this.searchDevice) {
        filters.ip_address = this.searchDevice;
      }

      this.loadDevices({
        pagination: 1,
        limit: this.universalOptions.itemsPerPage,
        page: this.universalOptions.page,
        filters,
      })
        .then((response) => {
          this.universalTotalDevices = response.meta.total;
        });
    },
    validate () {
      this.errorDevice = false;
      let tempDevice;
      let doorphonesGate;
      if (!this.selectedDevices.length) {
        this.$flash_danger('Заполните все поля');
        this.errorDevice = true;
        this.$refs.formAddController.validate();
        return;
      } else {
        tempDevice = this.selectedDevices[0].id;
      }

      if (this.selectedDoorphones === null || this.selectedDoorphones.length < 1) {
        this.$flash_danger('Привяжите домофон');
        return;
      } else {
        doorphonesGate = this.selectedDoorphones;
      }

      if (this.$refs.formAddController.validate()) {
        const tempBarrier = {
          device_id: tempDevice,
          doorphones: doorphonesGate,
          address: this.formController.address,
        };
        if (this.formController.name) {
          tempBarrier.name = this.formController.name;
        }
        if (this.formController.region && this.isDistrict) {
          tempBarrier.region_id = this.formController.region;
        }

        if (this.formController.region === null && this.isDistrict) {
          this.$flash_danger('Заполните поле "Район"');
        } else {
          this.newController(tempBarrier)
            .then(() => {
              this.$router.push({ name: 'Controllers' });
              this.$flash_success('Контроллер успешно создан');
            }).catch((error) => {
              this.$sentry_exception(error);
              this.$flash_warning('Ошибка при добавлении контроллера');
            });
        }
      } else {
        this.$flash_danger('Заполните все поля');
      }
    },
    returnControllers () {
      this.$router.push({ name: 'Controllers' });
    },
  },
  created () {
    const filters = { free: 1 };
    filters.model_id = '8';
    this.loadDevices({
      filters,
      pagination: 1,
      limit: this.universalOptions.itemsPerPage,
    })
      .then((response) => {
        this.universalTotalDevices = response.meta.total;
      })
      .catch((error) => {
        this.$sentry_exception(error);
        this.$flash_warning('Не удалось загрузить список устройств');
      });
    setTimeout(() => this.$nextTick(() => {
      this.isFirstLoading = false;
    }));
  },
};
</script>

<style lang="scss">
</style>
